import { useEffect, useState } from "react";

const compatibleLineIgnoreKey = (optimizationId: string, lineId: string) =>
  `${optimizationId}:${lineId}`;

export const useIgnoredCompatibleLines = (isPanelOpen: boolean) => {
  const [ignoredKeys, setIgnoredKeys] = useState<ReadonlySet<string>>(() => new Set());

  useEffect(() => {
    if (!isPanelOpen) {
      setIgnoredKeys((current) => (current.size === 0 ? current : new Set()));
    }
  }, [isPanelOpen]);

  const ignoreLine = (optimizationId: string, lineId: string) => {
    setIgnoredKeys((current) => {
      const next = new Set(current);
      next.add(compatibleLineIgnoreKey(optimizationId, lineId));
      return next;
    });
  };

  const isLineIgnored = (optimizationId: string, lineId: string) =>
    ignoredKeys.has(compatibleLineIgnoreKey(optimizationId, lineId));

  return { ignoreLine, isLineIgnored };
};
